export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const SET_SUB_HEADER = 'SET_SUB_HEADER';
export const SET_QUANTITY = 'SET_QUANTITY';
export const DESTROY_CART = 'DESTROY_CART';
export const ADD_TO_CART_BY_QUANTITY = 'ADD_TO_CART_BY_QUANTITY';
export const GET_CART = 'GET_CART';
export const VERIFY_PRODUCT_CART = 'VERIFY_PRODUCT_CART';